export default __webpack_public_path__ + "static/media/have.fc90eb9e.png";